import { type CustomThemeConfig, useGetTheme } from '@pba/react-theme';
import { useCallback } from 'react';

export type BorderRadiusKey = keyof CustomThemeConfig['border']['radius'];

export const useResolveBorderRadiusValue = () => {
  const { border } = useGetTheme();

  return useCallback(
    (value?: BorderRadiusKey): number | undefined => {
      if (value === undefined) {
        return undefined;
      }

      return border.radius[value].value;
    },
    [border],
  );
};
